var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-content',[_c('upload-button',{attrs:{"slot":"top-buttons"},on:{"on-success":_vm.upload},slot:"top-buttons"}),_c('filter-component'),_c('table-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }